import { useSelector } from 'react-redux';

import * as actions from '+/actions';
import * as apiCalls from '+/utils/apiCalls';

import useFetch from './useFetch';

const fetchActionTypeTemplates = async dispatch => {
  const actionTypeTemplatesData = await apiCalls.getAllActionTypeTemplates();
  if (actionTypeTemplatesData.errors) return;
  dispatch(actions.setAllActionTypeTemplates(actionTypeTemplatesData));
};

const useActionTypeTemplates = (refetch = false) => {
  const actionTypeTemplates = useSelector(state => state.actionTypeTemplates.all);

  const shouldFetch =
    refetch ||
    !actionTypeTemplates ||
    (actionTypeTemplates.isEmpty && actionTypeTemplates.isEmpty());

  useFetch(fetchActionTypeTemplates, shouldFetch);

  return actionTypeTemplates;
};

export default useActionTypeTemplates;
